import React, { useState } from 'react';
import Header from './Header.jsx';
import Footer from './Footer.jsx';
import banner from '../assets/banners/img2.avif';
import { FiMail, FiPhone, FiMapPin, FiSend, FiClock } from 'react-icons/fi';
import '../css/contactUs.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    subject: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate form submission
    setTimeout(() => {
      alert('Thank you for contacting us! We will get back to you soon.');
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        subject: '',
        message: ''
      });
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <>
      <Header />
      
      {/* Hero Banner Section */}
      <section className="contact-hero">
        <div className="contact-hero-background">
          <img
            src={banner}
            alt="contact"
            className="contact-hero-image"
          />
        </div>
        <div className="contact-hero-content">
          <h1 className="contact-hero-title">Contact Us</h1>
          <p className="contact-hero-subtitle">
            Get in touch with our team for inquiries, support.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="container">
          <div className="contact-wrapper">
            {/* Contact Information */}
            <div className="contact-info-section">
              <h2 className="contact-section-title">Get in Touch</h2>
              <p className="contact-section-description">
                We're here to help! Reach out to us for any questions about our products, 
                services, or to discuss your specific requirements.
              </p>

              <div className="contact-page-info-cards">
                <div className="contact-page-info-card">
                  <div className="contact-page-icon-wrapper">
                    <FiMail className="contact-page-icon" />
                  </div>
                  <div className="contact-page-info-content">
                    <h3 className="contact-page-info-title">Email</h3>
                    <p className="contact-page-info-value">naikars@anuflowcontrols.com</p>
                  </div>
                </div>

                <div className="contact-page-info-card">
                  <div className="contact-page-icon-wrapper">
                    <FiPhone className="contact-page-icon" />
                  </div>
                  <div className="contact-page-info-content">
                    <h3 className="contact-page-info-title">Phone</h3>
                    <p className="contact-page-info-value">+91 8488880446</p>
                  </div>
                </div>

                <div className="contact-page-info-card">
                  <div className="contact-page-icon-wrapper">
                    <FiMapPin className="contact-page-icon" />
                  </div>
                  <div className="contact-page-info-content">
                    <h3 className="contact-page-info-title">Address</h3>
                    <p className="contact-page-info-value">Shed - C 9, 7th Main Road, KSSIDC</p>
                    <p className="contact-page-info-value">Gamanagatti Industrial Area, Hubballi</p>
                    <p className="contact-page-info-value">Karnataka - 580025</p>
                  </div>
                </div>

                <div className="contact-page-info-card">
                  <div className="contact-page-icon-wrapper">
                    <FiClock className="contact-page-icon" />
                  </div>
                  <div className="contact-page-info-content">
                    <h3 className="contact-page-info-title">Business Hours</h3>
                    <p className="contact-page-info-value">Monday - Friday: 9:00 AM - 6:00 PM</p>
                    <p className="contact-page-info-value">Saturday: 9:00 AM - 1:00 PM</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-section">
              <h2 className="contact-section-title">Send us a Message</h2>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name" className="form-label">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="form-input"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Enter your full name"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email" className="form-label">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-input"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="Enter your email"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone" className="form-label">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      className="form-input"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Enter your phone number"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="company" className="form-label">Company Name</label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      className="form-input"
                      value={formData.company}
                      onChange={handleChange}
                      placeholder="Enter your company name"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="subject" className="form-label">Subject *</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    className="form-input"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder="Enter message subject"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message" className="form-label">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    className="form-textarea"
                    rows="6"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    placeholder="Enter your message here..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="submit-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    'Sending...'
                  ) : (
                    <>
                      <FiSend className="submit-icon" />
                      Send Message
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default ContactUs;








